import { useId } from "react";

export default function Sparkline({
    data,
    width = 140,
    height = 40,
    stroke = "#00D1FF",
    fill = true,
    strokeWidth = 1.6,
    className = "",
}) {
    const id = useId();
    const min = Math.min(...data);
    const max = Math.max(...data);
    const range = max - min || 1;
    const step = width / (data.length - 1);
    const pts = data.map(
        (v, i) =>
            `${(i * step).toFixed(2)},${(height - 3 - ((v - min) / range) * (height - 6)).toFixed(2)}`
    );
    const line = `M${pts.join(" L")}`;
    const area = `${line} L${width},${height} L0,${height} Z`;

    return (
        <svg
            viewBox={`0 0 ${width} ${height}`}
            preserveAspectRatio="none"
            className={className}
            aria-hidden="true"
        >
            {fill && (
                <>
                    <defs>
                        <linearGradient id={`sg-${id}`} x1="0" y1="0" x2="0" y2="1">
                            <stop offset="0%" stopColor={stroke} stopOpacity="0.26" />
                            <stop offset="100%" stopColor={stroke} stopOpacity="0" />
                        </linearGradient>
                    </defs>
                    <path d={area} fill={`url(#sg-${id})`} />
                </>
            )}
            <path
                d={line}
                fill="none"
                stroke={stroke}
                strokeWidth={strokeWidth}
                strokeLinejoin="round"
                strokeLinecap="round"
                vectorEffect="non-scaling-stroke"
            />
        </svg>
    );
}
